import { Button, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const ActionBtn = styled(Button).attrs((props) => ({
  color: "link",
  fontSize: "14px",
  fontWeight: "500",
  letterSpacing: "normal",
  mx: 2,
  variant: "text",
  ...props,
}))`
  text-decoration: underline;
  svg {
    vertical-align: text-bottom;
  }
  :hover {
    text-decoration: none;
  }
`

export const Text = styled(Typography).attrs((props) => ({
  fontSize: "14px",
  letterSpacing: "-0.03em",
  lineHeight: "16px",
  mb: "4px",
  ...props,
}))`
  ${(props) =>
    props.holidayStyle || props.cutoffStyle
      ? `
    span {
      font-weight: 700;
    }
  `
      : `
    color: ${props.theme.colors.neutral};
    span {
      color: #008000;
    }
  `}
  
  ${(props) =>
    props.holidayStyle &&
    (props.second
      ? `
      color: ${props.theme.colors.neutral};
      line-height: 30px;
      ${props.theme.mediaQueries.tablet`
        color: ${props.theme.colors.black};
        line-height: 16px;
      `}
    `
      : `
      background: #FCF2F2;
      border-radius: 30px;
      color: ${props.theme.colors.sale};
      display: inline-block;
      margin-bottom: 0;
      padding: 10px 16px;
      ${props.theme.mediaQueries.tablet`
        background: none;
        border-radius: 0;
        margin-bottom: 4px;
        padding: 0;
      `}
  `)}

  ${(props) =>
    props.cutoffStyle &&
    (props.second
      ? `
      color: ${props.theme.colors.black};
    `
      : `
      color: ${props.theme.colors.sale};
      font-weight: 700;
      span {
        color: ${props.theme.colors.sale};
      }
  `)}
`
